import { createSlice, current } from '@reduxjs/toolkit';
import {
	getFuelSupplyList,
	getFuelSupplyListFilter,
	addNewFuelSupply,
	updateFuelSupply,
	deleteFuelSupply,
	getFuelSupply,
	getFuelSupplySummary,
	getFuelSupplySummaryByEstablishment,
	getFuelSupplySummaryByMonth,
	getConsumptionByEstablishment,
	getConsumptionTypeSummary,
	getHourMeterSummary,
	getEmissionsSummary,
	getConsumptionsSummary,
} from '../fuelSupply/thunk';

export const initialState = {
	fuelSupplyByEstablishment: {},
	hourmeterSummary: {},
	fuelSupplySummary: [],
	emissionsSummary: [],
	consumptionsSummary: [],
	emissionsSummaryManagement: null,
	consumptionsSummaryManagement: null,

	itemFuelSupplyList: [],
	itemFuelSupplyMonth: [],
	itemFuelSupplyDetail: null,
	isFuelSupplyLoading: false,
	isFuelSupplySuccess: false,

	fuelSupplyList: [],
	fuelSupplyListSelect: [],
	fuelSupplyListFilter: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: '',
};

const FuelSupplySlice = createSlice({
	name: 'FuelSupply',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		clearDashboardData(state) {
			// Clear specific dashboard data to prevent animation flickering
			state.fuelSupplyByEstablishment = {};
			state.hourmeterSummary = {};
			state.fuelSupplySummary = [];
			state.emissionsSummaryManagement = null;
			state.consumptionsSummaryManagement = null;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFuelSupply.fulfilled, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = true;
			state.itemFuelSupplyDetail = action.payload;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFuelSupply.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelSupply.rejected, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getFuelSupplySummary.fulfilled, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = true;
			state.itemFuelSupplyList = action.payload;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFuelSupplySummary.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelSupplySummary.rejected, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(
			getFuelSupplySummaryByEstablishment.fulfilled,
			(state, action) => {
				state.isFuelSupplyLoading = false;
				state.isFuelSupplySuccess = true;
				state.itemFuelSupplyList = action.payload;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = true;
			}
		);
		builder.addCase(getFuelSupplySummaryByEstablishment.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(
			getFuelSupplySummaryByEstablishment.rejected,
			(state, action) => {
				state.isFuelSupplyLoading = false;
				state.isFuelSupplySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.error = action.error.message;
			}
		);

		builder.addCase(
			getFuelSupplySummaryByMonth.fulfilled,
			(state, action) => {
				state.isFuelSupplyLoading = false;
				state.isFuelSupplySuccess = true;
				state.itemFuelSupplyMonth = action.payload;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = true;
			}
		);
		builder.addCase(getFuelSupplySummaryByMonth.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelSupplySummaryByMonth.rejected, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getFuelSupplyList.pending, state => {
			state.isFuelSupplySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFuelSupplyList.fulfilled, (state, action) => {
			state.itemFuelSupplyList = action.payload;
			state.fuelSupplyList = action.payload;
			state.isLoadingList = false;
			state.isFuelSupplySuccess = true;

			let fuelSupplyListSelect = [];
			action.payload.map(item =>
				fuelSupplyListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.fuelSupplyListSelect = fuelSupplyListSelect;
		});
		builder.addCase(getFuelSupplyList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFuelSupplySuccess = true;
		});

		builder.addCase(getFuelSupplyListFilter.pending, state => {
			state.isFuelSupplySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFuelSupplyListFilter.fulfilled, (state, action) => {
			state.fuelSupplyListFilter = action.payload;
			state.isLoadingList = false;
			state.isFuelSupplySuccess = true;

			let fuelSupplyListSelect = [];
			action.payload.map(item =>
				fuelSupplyListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.fuelSupplyListSelect = fuelSupplyListSelect;
		});
		builder.addCase(getFuelSupplyListFilter.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFuelSupplySuccess = true;
		});

		builder.addCase(addNewFuelSupply.fulfilled, (state, action) => {
			state.itemFuelSupplyList.push(action.payload);
			state.fuelSupplyList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFuelSupply.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFuelSupply.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFuelSupply.fulfilled, (state, action) => {
			state.itemFuelSupplyList = state.itemFuelSupplyList.map(fuelSupply =>
				fuelSupply.fuelSupplyname === action.payload.old_fuelSupply
					? { ...fuelSupply, ...action.payload.updated_fuelSupply }
					: fuelSupply
			);
			state.fuelSupplyList = state.fuelSupplyList.map(fuelSupply =>
				fuelSupply._id.toString() === action.payload._id.toString()
					? { ...fuelSupply, ...action.payload }
					: fuelSupply
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFuelSupply.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFuelSupply.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFuelSupply.fulfilled, (state, action) => {
			state.itemFuelSupplyList = current(state.itemFuelSupplyList).filter(
				item => item._id !== action.payload._id
			);
			state.fuelSupplyList = current(state.fuelSupplyList).filter(
				item => item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFuelSupply.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFuelSupply.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		builder.addCase(
			getConsumptionByEstablishment.fulfilled,
			(state, action) => {
				if (!state.fuelSupplyByEstablishment) {
					state.fuelSupplyByEstablishment = {};
				}

				state.fuelSupplyByEstablishment[action.meta.arg.type] =
					action.payload; // Guardar solo la data, sin `establishment_id` ni `type`
				state.isFuelSupplyLoading = false;
				state.isFuelSupplySuccess = true;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = true;
			}
		);

		builder.addCase(
			getConsumptionByEstablishment.pending,
			(state, action) => {
				const { type } = action.meta.arg;

				if (!state.fuelSupplyByEstablishment) {
					state.fuelSupplyByEstablishment = {};
				}

				state.fuelSupplyByEstablishment[type] = {
					...state.fuelSupplyByEstablishment[type],
					isLoading: true,
				};

				state.isFuelSupplyLoading = true;
				state.isFuelSupplySuccess = null;
				state.error = null;
				state.isLoadingList = true;

				state.isLoading = true;
				state.isSuccess = false;
			}
		);

		builder.addCase(
			getConsumptionByEstablishment.rejected,
			(state, action) => {
				const { establishment_id, type } = action.meta.arg;

				if (!state.fuelSupplyByEstablishment) {
					state.fuelSupplyByEstablishment = {};
				}

				state.fuelSupplyByEstablishment[type] = {
					...state.fuelSupplyByEstablishment[type],
					isLoading: false,
					error: action.error.message,
				};

				state.isFuelSupplyLoading = false;
				state.isFuelSupplySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;

				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
			}
		);

		builder.addCase(getConsumptionTypeSummary.fulfilled, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = true;
			state.fuelSupplySummary = action.payload;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getConsumptionTypeSummary.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getConsumptionTypeSummary.rejected, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getHourMeterSummary.fulfilled, (state, action) => {
			if (!state.hourmeterSummary) {
				state.hourmeterSummary = {};
			}

			state.hourmeterSummary[action.meta.arg.type] = action.payload; // Guardar solo la data, sin `establishment_id` ni `type`
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = true;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = true;
		});

		builder.addCase(getHourMeterSummary.pending, (state, action) => {
			const { type } = action.meta.arg;

			if (!state.hourmeterSummary) {
				state.hourmeterSummary = {};
			}

			state.hourmeterSummary[type] = {
				...state.hourmeterSummary[type],
				isLoading: true,
			};

			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;

			state.isLoading = true;
			state.isSuccess = false;
		});

		builder.addCase(getHourMeterSummary.rejected, (state, action) => {
			const { establishment_id, type } = action.meta.arg;

			if (!state.hourmeterSummary) {
				state.fuelSupplyByEstablishment = {};
			}

			state.hourmeterSummary[type] = {
				...state.hourmeterSummary[type],
				isLoading: false,
				error: action.error.message,
			};

			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;

			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
		});

		builder.addCase(getEmissionsSummary.fulfilled, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = true;
			// If no establishment_id, it's a management view
			if (action.meta.arg.establishment_id) {
				state.emissionsSummary = action.payload;
			} else {
				state.emissionsSummaryManagement = action.payload;
			}
			state.isLoadingList = false;
		});
		builder.addCase(getEmissionsSummary.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEmissionsSummary.rejected, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getConsumptionsSummary.fulfilled, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = true;
			// If no establishment_id, it's a management view
			if (action.meta.arg.establishment_id) {
				state.consumptionsSummary = action.payload;
			} else {
				state.consumptionsSummaryManagement = action.payload;
			}
			state.isLoadingList = false;
		});
		builder.addCase(getConsumptionsSummary.pending, state => {
			state.isFuelSupplyLoading = true;
			state.isFuelSupplySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getConsumptionsSummary.rejected, (state, action) => {
			state.isFuelSupplyLoading = false;
			state.isFuelSupplySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal, clearDashboardData } =
	FuelSupplySlice.actions;

export default FuelSupplySlice.reducer;
